<template>
  <div class="the-footer">
    <div class="footer-in w1200">
      <div class="left">
        <img class="l-logo" src="../assets/img/公司LOGO@2x2.png" width="494" alt="公司logo">
        <p class="prop">电话：400-150-0896</p>
        <p class="prop">地址：安徽省合肥市滨湖区烟墩街道高速时代广场C7栋9-10楼</p>
        <p class="prop">邮箱：<a href="mailto:service@ahwater.net">service@ahwater.net</a></p>
      </div>
      <div class="mid">
        <h3 class="title">快速入口</h3>
        <a class="quick-item" target="_blank" href="http://ahwater.net">首页</a>
        <a class="quick-item" target="_blank" href="http://ahwater.net/cases">项目案例</a>
<!--        <a class="quick-item" target="_blank" href="http://ahwater.net/sector">事业板块</a>-->
        <a class="quick-item" target="_blank" href="http://ahwater.net/news">新闻资讯</a>
        <a class="quick-item" target="_blank" href="http://ahwater.net/product">产品中心</a>
        <a class="quick-item" target="_blank" href="http://ahwater.net/about">关于我们</a>
        <a class="quick-item" target="_blank" href="http://ahwater.net/solution">解决方案</a>
      </div>
      <div class="right">
        <img src="../assets/img/weixin.jpg" width="100%" height="100%" alt="微信公众号">
      </div>
    </div>
    <div class="footer-in w1200 has-bor">
      <div class="left">
        <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=34011102002449" target="_blank">
          <img src="http://www.beian.gov.cn/file/ghs.png"/>
          皖公网安备 34011102002449号
        </a>
        <a href="https://beian.miit.gov.cn/#/Integrated/recordQuery" target="_blank">皖ICP备16006513号-1</a>
      </div>
      <div class="links">
        <a href="http://waterweather.cn" target="_blank">沃特天气</a>
<!--        <a href="http://yc.wswj.net/ahsxx/LOL/?refer=upl&to=public_public" target="_blank">安徽水信息</a>-->
        <a href="http://ahswj.cn/ahsxx/LOL/?refer=upl&to=public_public" target="_blank">安徽水信息</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'whFooter'
}
</script>
<style lang="stylus">
.the-footer
  background: #0d1a2d;
  padding: 20px 0;
  box-sizing: border-box;

  .footer-in
    width: 1200px;
    box-sizing: border-box;
    margin: 0 auto;
    overflow hidden
    color: #76849f;

    a
      color: #76849f;

      &:hover
        color: $mainColor;

    &.has-bor
      margin-top: 30px;
      padding-top: 20px;
      border-top: 1px solid #76849f;

    .left
      float: left;

      .l-logo
        margin-bottom: 25px;

      .prop
        padding-left: 10px;
        line-height: 25px;
        margin-top: 15px;

      > a
        margin-right: 10px;

    .mid
      float: left;
      padding-top: 15px;
      width: 260px;
      margin-left: 90px;
      font-size: 0;

      .title
        font-size: 22px;
        color: #fff;
        margin-bottom: 20px;

      .quick-item
        display: inline-block;
        width: 50%;
        font-size: 14px;
        line-height: 25px;
        margin-bottom: 10px;
        cursor: pointer;

        &:hover
          color: $mainColor;

    .right
      float: right;
      margin-top: 15px;
      width: 217px;
      height: 217px;

    .links
      float: right;

      > a
        margin-left: 10px;
</style>